export default {
  format: 'media',
  viewBox: '0 0 80 80',
  markup: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
      <defs>
        <radialGradient
          id="a_firefox"
          cx="-1186.91"
          cy="-517.676"
          r="90.78"
          gradientTransform="translate(1258.441 534.061)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff36e" />
          <stop offset=".5" stopColor="#fc4055" />
          <stop offset="1" stopColor="#e31587" />
        </radialGradient>
        <radialGradient
          id="b_firefox"
          cx="-1251.812"
          cy="-513.921"
          r="53.726"
          gradientTransform="translate(1258.441 534.061)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".001" stopColor="#c60084" />
          <stop offset="1" stopColor="#fc4055" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="c_firefox"
          cx="-1179.15"
          cy="-522.842"
          r="106.599"
          gradientTransform="translate(1258.441 534.061)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffde67" stop-opacity=".6" />
          <stop offset=".093" stopColor="#ffd966" stop-opacity=".581" />
          <stop offset=".203" stopColor="#ffca65" stop-opacity=".525" />
          <stop offset=".321" stopColor="#feb262" stop-opacity=".432" />
          <stop offset=".446" stopColor="#fe8f5e" stop-opacity=".302" />
          <stop offset=".573" stopColor="#fd6459" stop-opacity=".137" />
          <stop offset=".664" stopColor="#fc4055" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="d_firefox"
          cx="42.285"
          cy="44.499"
          r="137.521"
          gradientTransform="translate(0 -.095)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".153" stopColor="#810220" />
          <stop offset=".167" stopColor="#920b27" stop-opacity=".861" />
          <stop offset=".216" stopColor="#cb2740" stop-opacity=".398" />
          <stop offset=".253" stopColor="#ef394f" stop-opacity=".11" />
          <stop offset=".272" stopColor="#fc4055" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="e_firefox"
          cx="31.878"
          cy="42.77"
          r="137.521"
          gradientTransform="translate(0 -.095)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".113" stopColor="#810220" />
          <stop offset=".133" stopColor="#920b27" stop-opacity=".861" />
          <stop offset=".204" stopColor="#cb2740" stop-opacity=".398" />
          <stop offset=".257" stopColor="#ef394f" stop-opacity=".11" />
          <stop offset=".284" stopColor="#fc4055" stop-opacity="0" />
        </radialGradient>
        <linearGradient
          id="f_firefox"
          x1="-1212.61"
          y1="-525.103"
          x2="-1189.052"
          y2="-484.299"
          gradientTransform="translate(1258.441 532.89)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ffbd4f" />
          <stop offset=".508" stopColor="#ff9640" stop-opacity="0" />
        </linearGradient>
        <radialGradient
          id="g"
          cx="-1255.933"
          cy="-77.395"
          r="88.863"
          gradientTransform="matrix(.959 0 0 .961 1273.896 86.468)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#ff9640" />
          <stop offset=".8" stopColor="#fc4055" />
        </radialGradient>
        <radialGradient
          id="h"
          cx="-1255.933"
          cy="-77.395"
          r="88.863"
          gradientTransform="matrix(.959 0 0 .961 1273.896 86.468)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".084" stopColor="#ffde67" />
          <stop offset=".147" stopColor="#ffdc66" stop-opacity=".968" />
          <stop offset=".246" stopColor="#ffd562" stop-opacity=".879" />
          <stop offset=".369" stopColor="#ffcb5d" stop-opacity=".734" />
          <stop offset=".511" stopColor="#ffbc55" stop-opacity=".533" />
          <stop offset=".667" stopColor="#ffaa4b" stop-opacity=".28" />
          <stop offset=".822" stopColor="#ff9640" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="i"
          cx="49.941"
          cy="38.654"
          r="41.79"
          gradientTransform="matrix(.247 .971 -1.011 .259 76.681 -19.851)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".363" stopColor="#fc4055" />
          <stop offset=".443" stopColor="#fd604d" stop-opacity=".633" />
          <stop offset=".545" stopColor="#fe8644" stop-opacity=".181" />
          <stop offset=".59" stopColor="#ff9640" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="j"
          cx="42.737"
          cy="42.193"
          r="41.79"
          gradientTransform="translate(0 -.095)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".216" stopColor="#fc4055" stop-opacity=".8" />
          <stop offset=".267" stopColor="#fd5251" stop-opacity=".633" />
          <stop offset=".41" stopColor="#fe8345" stop-opacity=".181" />
          <stop offset=".474" stopColor="#ff9640" stop-opacity="0" />
        </radialGradient>
        <radialGradient
          id="k"
          cx="-1238.198"
          cy="-87.433"
          r="150.195"
          gradientTransform="matrix(.959 0 0 .961 1273.896 86.468)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".054" stopColor="#fff36e" />
          <stop offset=".457" stopColor="#ff9640" />
          <stop offset=".639" stopColor="#ff9640" />
        </radialGradient>
        <linearGradient
          id="l"
          x1="59.052"
          y1="7.083"
          x2="18.155"
          y2="77.92"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#fff36e" stop-opacity=".8" />
          <stop offset=".094" stopColor="#fff36e" stop-opacity=".699" />
          <stop offset=".752" stopColor="#fff36e" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="m"
          x1="40.585"
          y1="-.67"
          x2="62.3"
          y2="62.203"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#b833e1" />
          <stop offset=".371" stopColor="#9059ff" />
          <stop offset=".614" stopColor="#5b6df8" />
          <stop offset="1" stopColor="#0090ed" />
        </linearGradient>
        <linearGradient
          id="n"
          x1="-1230.731"
          y1="-532.566"
          x2="-1190.37"
          y2="-492.205"
          gradientTransform="translate(1258.441 532.89)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".805" stopColor="#722291" stop-opacity="0" />
          <stop offset="1" stopColor="#592acb" stop-opacity=".5" />
        </linearGradient>
      </defs>
      <path
        d="M71.944 15.7A39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522c15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7zm-63.4 3.487z"
        fill="url(#a_firefox)"
      />
      <path
        d="M71.944 15.7A39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522c15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7zm-63.4 3.487z"
        fill="url(#b_firefox)"
        opacity=".67"
      />
      <path
        d="M71.944 15.7A39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522c15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7zm-63.4 3.487z"
        fill="url(#c_firefox)"
      />
      <path
        d="M71.944 15.7A39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522c15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7zm-63.4 3.487z"
        fill="url(#d_firefox)"
      />
      <path
        d="M71.944 15.7A39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522c15.83.2 32.832 10.981 35.357 30.413 2.9 22.306-12.637 40.923-34.493 40.98-24.045.061-38.67-21.229-34.847-40.352a19.735 19.735 0 0 1 .413-2.787 37.815 37.815 0 0 1 4.193-14.018c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7zm-63.4 3.487z"
        fill="url(#e_firefox)"
      />
      <path
        d="M75.651 30.935a41.01 41.01 0 0 1 .3 7.247q1.99-.3 3.987-.53A40.01 40.01 0 0 0 71.944 15.7 39.47 39.47 0 0 0 41.588.009C32.3-.177 25.884 2.614 22.254 4.858 27.111 2.041 34.14.443 40.294.522 56.124.724 73.126 11.5 75.651 30.935z"
        fill="url(#f_firefox)"
      />
      <path
        d="M76.625 29.826C74.374 9.518 56.263.39 40.294.522c-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0-3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572A43.5 43.5 0 0 1 40.84 1.5a33.254 33.254 0 0 1 31.25 31.993C72.457 46.7 61.648 57.23 49.188 57.84c-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1-1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z"
        fill="url(#g)"
      />
      <path
        d="M76.625 29.826C74.374 9.518 56.263.39 40.294.522c-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0-3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572A43.5 43.5 0 0 1 40.84 1.5a33.254 33.254 0 0 1 31.25 31.993C72.457 46.7 61.648 57.23 49.188 57.84c-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1-1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z"
        fill="url(#h)"
      />
      <path
        d="M76.625 29.826C74.374 9.518 56.263.39 40.294.522c-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0-3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572A43.5 43.5 0 0 1 40.84 1.5a33.254 33.254 0 0 1 31.25 31.993C72.457 46.7 61.648 57.23 49.188 57.84c-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1-1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z"
        style={{ mixBlendMode: 'multiply' }}
        opacity=".53"
        fill="url(#i)"
      />
      <path
        d="M76.625 29.826C74.374 9.518 56.263.39 40.294.522c-6.155.05-13.183 1.519-18.04 4.336a19.7 19.7 0 0 0-3.56 2.7c.129-.107.514-.424 1.152-.862l.063-.043.056-.038a26.655 26.655 0 0 1 7.692-3.572A43.5 43.5 0 0 1 40.84 1.5a33.254 33.254 0 0 1 31.25 31.993C72.457 46.7 61.648 57.23 49.188 57.84c-9.062.444-17.6-3.941-21.77-12.713a21.68 21.68 0 0 1-1.964-6.333c-1.976-13.35 6.989-24.735 15.21-27.554-4.435-3.874-15.548-3.611-23.819 2.474-5.956 4.382-9.82 11.049-11.1 19a32.945 32.945 0 0 0 2.34 18 35.3 35.3 0 0 0 30.089 21.443q1.489.114 2.984.113c26.462 0 37.942-20.087 35.467-42.444z"
        style={{ mixBlendMode: 'multiply' }}
        opacity=".53"
        fill="url(#j)"
      />
      <path
        d="M49.188 57.84c17.1-1.04 24.42-15.2 24.879-25.245C74.783 16.9 65.472-.02 40.84 1.5a43.5 43.5 0 0 0-13.183 1.546 28.855 28.855 0 0 0-7.692 3.572l-.056.038-.063.043q-.574.4-1.123.842A33.482 33.482 0 0 1 39.7 3.605c14.142 1.856 27.072 12.857 27.072 27.373 0 11.169-8.631 19.7-18.738 19.087-15.015-.9-18.8-16.3-10.989-22.954-2.106-.453-6.064.435-8.82 4.555-2.473 3.7-2.333 9.41-.807 13.461a22.118 22.118 0 0 0 21.77 12.713z"
        fill="url(#k)"
      />
      <path
        d="M71.944 15.7a39.958 39.958 0 0 0-3.482-3.982 31.342 31.342 0 0 0-3.177-2.926 24.393 24.393 0 0 1 1.849 1.79 22.466 22.466 0 0 1 4.882 8.144c2.089 6.329 1.953 14.25-2.036 20.471a23.539 23.539 0 0 1-20.855 10.895c-.361 0-.725 0-1.091-.027-15.015-.9-18.8-16.3-10.988-22.954-2.107-.453-6.065.435-8.821 4.555-2.473 3.7-2.333 9.41-.807 13.461a21.679 21.679 0 0 1-1.963-6.333c-1.977-13.35 6.988-24.735 15.209-27.554-4.435-3.874-15.548-3.611-23.819 2.474a27.845 27.845 0 0 0-10.087 14.6 38.5 38.5 0 0 1 4.159-13.553c-2.769 1.433-6.295 5.965-8.035 10.163A41.355 41.355 0 0 0 .284 45.1c.06.518.114 1.035.182 1.549A40.062 40.062 0 1 0 71.944 15.7z"
        fill="url(#l)"
      />
      <path
        d="M72.016 18.726a22.458 22.458 0 0 0-4.882-8.144 30.224 30.224 0 0 0-9.094-6.493A40.518 40.518 0 0 0 49.1.92a39.834 39.834 0 0 0-16.565-.1c-5.683 1.2-10.68 3.659-13.841 6.733a32.1 32.1 0 0 1 8.031-3.2 33.565 33.565 0 0 1 31.173 8.1 27.01 27.01 0 0 1 4.329 5.3c4.895 7.959 4.432 17.965.615 23.866-2.835 4.384-8.907 8.5-14.572 8.452A23.629 23.629 0 0 0 69.98 39.2c3.989-6.224 4.125-14.145 2.036-20.474z"
        fill="url(#m)"
      />
      <path
        d="M72.016 18.726a22.458 22.458 0 0 0-4.882-8.144 30.224 30.224 0 0 0-9.094-6.493A40.518 40.518 0 0 0 49.1.92a39.834 39.834 0 0 0-16.565-.1c-5.683 1.2-10.68 3.659-13.841 6.733a32.1 32.1 0 0 1 8.031-3.2 33.565 33.565 0 0 1 31.173 8.1 27.01 27.01 0 0 1 4.329 5.3c4.895 7.959 4.432 17.965.615 23.866-2.835 4.384-8.907 8.5-14.572 8.452A23.629 23.629 0 0 0 69.98 39.2c3.989-6.224 4.125-14.145 2.036-20.474z"
        fill="url(#n)"
      />
    </svg>
  ),
};
